import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";
import { GetBaseURL } from "../../../utils/urlUtils";

const HeaderBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || (state.documentType === "invoice" ? "INVOICE" : "ACCOUNT SUMMARY");
  const logoUrl = state.firm?.branding?.logoUrl && state.firm?._id
    ? `${GetBaseURL()}/api/firm/logo/${state.firm._id}`
    : null;

  return (
    <div className="flex items-start justify-between pb-6 border-b-2" style={{ borderColor: "var(--color-primary)" }}>
      <div>
        {logoUrl ? (
          <img src={logoUrl} alt="Logo" className="h-12 mb-2 object-contain" />
        ) : (
          <h2 className="text-xl font-bold text-slate-800">{state.firm?.name || "Law Firm"}</h2>
        )}
        {state.firm?.address && (
          <div className="text-xs text-slate-500 mt-1 space-y-0.5">
            {state.firm.address.line1 && <p>{state.firm.address.line1}</p>}
            {state.firm.address.city && (
              <p>
                {state.firm.address.city}
                {state.firm.address.region ? `, ${state.firm.address.region}` : ""}
                {state.firm.address.postal ? ` ${state.firm.address.postal}` : ""}
              </p>
            )}
          </div>
        )}
      </div>
      <div className="text-right">
        <h1 className="text-2xl font-bold tracking-wide" style={{ color: "var(--color-primary)" }}>
          {heading}
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Date: {new Date().toLocaleDateString("en-CA")}
        </p>
      </div>
    </div>
  );
};

export default HeaderBlock;
